import React, { useState } from 'react';
import BetaSignupForm from './BetaSignupForm';

interface TemperatureControlProps {
  onBetaSignupComplete?: (firstName: string) => void;
  onBetaSignupFormOpen?: () => void;
  isOpenMode?: boolean;
}

const TemperatureControl: React.FC<TemperatureControlProps> = ({
  onBetaSignupComplete,
  onBetaSignupFormOpen,
  isOpenMode = false
}) => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <div style={{
      position: 'relative'
    }}>
      {/* Join the Beta Button */}
      <button
        onClick={() => {
          setIsFormOpen(true);
          onBetaSignupFormOpen?.();
        }}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '8px 16px',
          fontSize: '12px',
          fontWeight: '600',
          backgroundColor: '#ff6b6b',
          color: 'white',
          border: 'none',
          borderRadius: '20px',
          cursor: 'pointer',
          transition: 'all 0.2s',
          width: '100%',
          justifyContent: 'center'
        }}
        onMouseOver={(e) => {
          (e.target as HTMLButtonElement).style.backgroundColor = '#ff5252';
          (e.target as HTMLButtonElement).style.transform = 'translateY(-1px)';
        }}
        onMouseOut={(e) => {
          (e.target as HTMLButtonElement).style.backgroundColor = '#ff6b6b';
          (e.target as HTMLButtonElement).style.transform = 'translateY(0px)';
        }}
      >
        <span>🚀</span>
        <span>Join the Beta</span>
      </button>

      {/* Open Mode Indicator */}
      {isOpenMode && (
        <div style={{
          marginTop: '8px',
          padding: '6px 12px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '12px',
          textAlign: 'center',
          border: '1px solid rgba(255, 255, 255, 0.3)'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            color: 'white',
            fontSize: '11px',
            fontWeight: '600'
          }}>
            <span style={{ fontSize: '14px' }}>🎨</span>
            <span>Open Mode Active</span>
          </div>
        </div>
      )}

      {/* Beta Signup Form Modal */}
      <BetaSignupForm
        isOpen={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        onFormSubmitted={onBetaSignupComplete}
      />
    </div>
  );
};

export default TemperatureControl;